function slugify(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function getPageName() {
  const path = window.location.pathname || "/";
  return slugify(path === "/" ? "home" : path.replace(/\//g, "-"));
}

function getElementType(el) {
  const tag = el.tagName.toLowerCase();

  if (tag === "button") return "button";
  if (tag === "input") return "input";
  if (tag === "select") return "select";
  if (tag === "textarea") return "textarea";
  if (tag === "form") return "form";
  if (tag === "a") return "link";

  return tag;
}

function shouldProcess(el) {
  if (!(el instanceof HTMLElement)) return false;
  if (el.dataset.autoidLocked === "true") return false;
  if (el.dataset.autoidManual === "true") return false;

  const allowedTags = [
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "FORM",
    "A",
    "DIV",
    "SPAN"
  ];

  return allowedTags.includes(el.tagName);
}

function assignSimpleAutoIds(rootSelector = "body") {
  const root = document.querySelector(rootSelector);
  if (!root) return;

  const pageName = getPageName();
  const counters = {};

  const elements = root.querySelectorAll("*");

  elements.forEach((el) => {
    if (!shouldProcess(el)) return;

    const type = getElementType(el);
    const key = `${pageName}-${type}`;

    counters[key] = (counters[key] || 0) + 1;

    el.dataset.autoid = `${pageName}-${type}-${counters[key]}`;
  });
}

function initSimpleAutoIdManager(rootSelector = "body") {
  const root = document.querySelector(rootSelector);
  if (!root) return;

  const run = () => assignSimpleAutoIds(rootSelector);

  run();

  const observer = new MutationObserver(() => {
    run();
  });

  observer.observe(root, {
    childList: true,
    subtree: true,
  });

  return () => observer.disconnect();
}

export { initSimpleAutoIdManager };